import { GameRecordsBase } from '../../shared/models/game-records-base';
import type { GameRecordOptions } from '../../shared/models/game-record-base';
import { MlbGameRecord } from './game-record';
import type { IGame } from '../../shared/interfaces/IGame';

/**
 * MLB-specific GameRecords.
 * - teamName is a plain string.
 * - Denominator is W+L only (no ties in denominator).
 * - zeroPctValue: -1.
 */
export class MlbGameRecords extends GameRecordsBase {
  protected override get recordOptions(): Partial<GameRecordOptions> {
    return MlbGameRecord.MLB_OPTIONS;
  }

  constructor(
    Wins: KnockoutObservableArray<IGame>,
    Losses: KnockoutObservableArray<IGame>,
    Ties: KnockoutObservableArray<IGame>,
    teamName: string,
    fakeObs: KnockoutObservable<number | undefined>
  ) {
    super(Wins, Losses, Ties, teamName, fakeObs);
  }
}
